<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content class="has-table">
    <!-- TODO make these inputs dynamic to this dialog as other parents call it and need them dynamic -->
    <lf-member-selector [showEmail]="true" [showAddress]="false"
                        [preselectedMemberIds]="data.preselectedMemberIds"
                        (onSelect)="updateMembers($event)"></lf-member-selector>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-dialog-close="" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="closeAndConfirm()" class="btn btn-primary">Select</button>
</mat-dialog-actions>
